/**
 * @param {string} str
 */
export default function slugify(str) {
  let slugifiedString = '';

  if (str) {
    slugifiedString = str.replace(/^\s+|\s+$/g, '').toLowerCase();

    // remove accents, swap ñ for n, etc
    const from = 'åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;.';
    const to = 'aaaaaaeeeeiiiioooouuuunc-------';

    for (let i = 0, l = from.length; i < l; i++) {
      const char = `\\${from.charAt(i)}`;
      slugifiedString = slugifiedString.replace(
        new RegExp(char, 'g'),
        to.charAt(i)
      );
    }

    slugifiedString = slugifiedString
      .replace(/[^a-z0-9 -]/g, '-') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-') // collapse dashes
      .replace(/^-+/, '') // trim - from start of text
      .replace(/-+$/, ''); // trim - from end of text
  }

  return slugifiedString;
}
